module.exports = __webpack_public_path__ + "static/media/sv.53797b21.png";